"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRolEchainPartsV1Utils = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const ExchangeRolEchainPartsV1_1 = require("./ExchangeRolEchainPartsV1");
class ExchangeRolEchainPartsV1Utils {
    static create({ rolEchain }) {
        const calculator = echain_shared_articles_oo_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
        const totalWeight = calculator.calcTotalWeight(rolEchain);
        const numLinks = calculator.calcNumLinksByType(rolEchain);
        const exchangeRolEchainParts = {
            NumLinks: this.mapNumLinksToExchangeFormat(numLinks),
            TotalWeight: totalWeight.toJson(),
            BendRadius: rolEchain.Biegeradius,
            RolLink: this.extractLink(rolEchain, 'RolLink'),
            StandardLink: this.extractLink(rolEchain, 'StandardLink'),
            AdapterLink: this.extractLink(rolEchain, 'AdapterLink'),
            AutoglideLink: this.extractLink(rolEchain, 'AutoglideLink'),
            ModifiedLink: this.extractLink(rolEchain, 'ModifiedLink'),
        };
        if (!(0, ExchangeRolEchainPartsV1_1.isExchangeRolEchainPartsV1)(exchangeRolEchainParts)) {
            throw new Error(`${this.className}.create(): Could not create a valid ExchangeRolEchainPartsV1`);
        }
        return exchangeRolEchainParts;
    }
    static mapNumLinksToExchangeFormat(numLinks) {
        const mapDef = {
            numRolLinks: 'NumRolLinks',
            numStandardLinks: 'NumStandardLinks',
            numAdapterLinks: 'NumAdapterLinks',
            numAutoglideLinks: 'NumAutoglideLinks',
            numModifiedLinks: 'NumModifiedLinks',
        };
        const exchangeNumLinks = {};
        Object.entries(numLinks).forEach(([key, value]) => {
            exchangeNumLinks[mapDef[key]] = value;
        });
        if (!(0, ExchangeRolEchainPartsV1_1.isExchangeRolEchainPartsNumLinksV1)(exchangeNumLinks)) {
            throw new Error(`${this.className}.mapNumLinksToExchangeFormat(): Could not create a valid ExchangeRolEchainPartsNumLinksV1`);
        }
        return exchangeNumLinks;
    }
}
exports.ExchangeRolEchainPartsV1Utils = ExchangeRolEchainPartsV1Utils;
ExchangeRolEchainPartsV1Utils.className = 'ExchangeRolEchainPartsV1Utils';
ExchangeRolEchainPartsV1Utils.extractLink = (r, linkKey) => {
    const link = r[linkKey];
    return link
        ? {
            ArtNr: link.ArtNr,
            ArtNrDE: link.ArtNrDE,
            ArtNrUS: link.ArtNrUS,
        }
        : undefined;
};
//# sourceMappingURL=ExchangeRolEchainPartsV1Utils.js.map